export default __webpack_public_path__ + "static/media/experts.2d10fd01.jpg";